import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnderline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 19.25h14.5M16.25 4.75V11a4.25 4.25 0 0 1-8.5 0V4.75"
    />
  </svg>
);
export default SvgUnderline;
